import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Container, Form, Input, Label, Row, } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import "flatpickr/dist/themes/material_blue.css";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import { Controller, useForm } from "react-hook-form";
import { post } from "helpers/api_helper";
import { CUSTOMER_CREATE } from "helpers/url_helper";
import { Navigate } from "react-router-dom";

const CreateCustomer = () => {
  useEffect(() => {
    window.google && window.google.load("elements", "1", {
      packages: "transliteration",
      callback: onLoadTransliteration,
    });

    function onLoadTransliteration() {
      const control = new window.google.elements.transliteration.TransliterationControl({
        sourceLanguage: window.google.elements.transliteration.LanguageCode.ENGLISH,
        destinationLanguage: [window.google.elements.transliteration.LanguageCode.GUJARATI],
        transliterationEnabled: true,
      });

      control.makeTransliteratable(["name", "address", "notes"]);
    }
  }, []);
  const {
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    control,
  } = useForm({
    defaultValues: {
      phone: "",
      name: "",
      email: "",
      Discount: "",
      date: new Date().toISOString().slice(0, 10),
      remarks: "",
      customer_status: "1",
      address: "",    
    },
  });

  const breadcrumbItems = [
    { title: "valfuel", link: "/" },
    { title: "Add Customers", link: "#" },
  ];
  
  const onSubmit = async (value) => {
    const payload = {
      ...value,
      status: value?.customer_status,
    };
    try {
      await post(CUSTOMER_CREATE, payload);
      toastr.success("Employee created successfully!");
      Navigate("/customer");
    } catch (error) {
      toastr.success("Employee creation failed!");
    } finally {
      reset();
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Add Customer" breadcrumbItems={breadcrumbItems} />
        </Container>

        <Row>
          <Col xl="12">
            <Card>
              <CardBody>
                <Form
                  className="needs-validation"
                  method="post"
                  id="customerCreateForm"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <Row>
                    <Col md="6" xl="4">
                      <div className="mb-3 position-relative">
                        <Label className="form-label" htmlFor="phone">
                          Phone No <span className="text-danger">*</span>
                        </Label>

                        <Controller
                          name="phone"
                          control={control}
                          rules={{
                            required: "Phone number is required",
                            pattern: {
                              value: /^[0-9]*$/, // only numbers
                              message: "Please enter only numbers",
                            },
                            minLength: {
                              value: 10,
                              message: "Must be 10-digits phone number",
                            },
                            maxLength: {
                              value: 10,
                              message: "Must be 10-digits phone number",
                            },
                          }}
                          render={({ field }) => (
                            <Input
                              {...field}
                              id="phone"
                              placeholder="Enter Phone no"
                              type="tel" // opens phone's dial pad
                              inputMode="numeric" // fallback to show numeric keyboard
                              pattern="[0-9]*"
                              maxLength="10"
                              onKeyDown={(e) => {
                                // block non-digits
                                if (!/[0-9]|Backspace|ArrowLeft|ArrowRight|Tab|Delete/.test(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              className={`form-control ${errors.phone_no ? "is-invalid" : ""
                                }`}
                            />
                          )}

                        />
                        {errors.phone?.message && (
                          <div className="text-danger">
                            {errors.phone.message}
                          </div>
                        )}

                      </div>
                    </Col>
                    <Col md="6" xl="4">
                      <div className="mb-3 position-relative">
                        <Label
                          className="form-label"
                          htmlFor="validationTooltip03"
                        >
                          Email
                          <span className="text-danger">*</span>
                        </Label>
                        <Controller
                          name="email"
                          control={control}
                          rules={{
                            required: "Email is required",
                            pattern: {
                              value:
                                /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                              message: "Invalid email format",
                            },
                          }}
                          render={({ field }) => (
                            <Input
                              {...field}
                              type="text"
                              className={`form-control ${
                                errors.email ? "is-invalid" : ""
                              }`}
                              id="email"
                              placeholder="Enter Email"
                            />
                          )}
                        />
                        {errors.email?.message && (
                          <div className="text-danger">
                            {errors.email.message}
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col md="6" xl="4">
                      <div className="mb-3 position-relative">
                        <label className="form-label" htmlFor="name"> Name </label>
                        <Controller name="name" control={control} render={({ field }) => (
                            <Input
                              {...field}
                              type="text"
                              className={`form-control ${errors.name ? "is-invalid" : ""
                                }`}
                              id="name"
                              placeholder="Enter name"
                            />
                          )}
                        />
                      </div>
                    </Col>
                    <Col md="6" xl="4">
                      <div className="mb-3 position-relative">
                        <Label
                          className="form-label">
                          Discount
                        </Label>
                        <Controller
                          name="Discount"
                          control={control}
                          render={({ field }) => (
                            <Input
                              {...field}
                              type="text"
                              className={`form-control ${errors.Discount ? "is-invalid" : ""
                                }`}
                              id="Discount"
                              placeholder="Enter Discount"
                            />
                          )}
                        />
                        {errors.Discount?.message && (
                          <div className="text-danger">
                            {errors.Discount.message}
                          </div>
                        )}
                      </div>
                    </Col>                               
                     <Col md="12" xl="12">
                      <div className="mb-3 position-relative">
                        <Label className="form-label" htmlFor="Remarks">
                          Remarks
                        </Label>
                        <Controller
                          name="Remarks"
                          control={control}
                          render={({ field }) => (
                            <Input
                              {...field}
                              type="textarea"
                              style={{ height: "80px" }} 
                              className={`form-control9 `}
                              id="Remarks"
                              placeholder="Enter Remarks"
                            />
                          )}
                        />
                      </div>
                    </Col> 
                  </Row>
                 <div className="text-end">
                    <Button type="submit" color="primary" disabled={isSubmitting}>
                        {isSubmitting ? "Submitting..." : "Submit"}
                      </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default CreateCustomer;
